var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loader)?_c('div',{staticClass:"pag-loader"},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"primary","indeterminate":"","id":"loading"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }